'use client';

import { getClientApplicationConfig } from '@hc-frontend/core-context';
import { usePathname } from 'next/navigation';
import Script from 'next/script';

import { CriteoGum } from '../presentation/atoms/tracking-pixels/criteo-gum';
import { FacebookPixel } from '../presentation/atoms/tracking-pixels/facebook-pixel';
import { GA4Pixel } from '../presentation/atoms/tracking-pixels/ga4-pixel';
import { RedditPixel } from '../presentation/atoms/tracking-pixels/reddit-pixel';

/**
 * Global scripts loaded on all pages
 * Marketing and analytics scripts are gated by consent - only load if user accepts all cookies
 */
export function GlobalScripts() {
  const config = getClientApplicationConfig();
  const pathname = usePathname();

  if (pathname.startsWith('/widgets')) {
    return null;
  }

  const OSANO_CUSTOMER_ID = 'wgsXXPj3qR';
  const OSANO_CONFIG_ID = '7bf45c8e-cfbe-4731-8059-e32512009be7';

  return (
    <>
      <Script
        id="osano-cmp-script"
        src={`https://cmp.osano.com/${OSANO_CUSTOMER_ID}/${OSANO_CONFIG_ID}/osano.js`}
        strategy="lazyOnload"
      ></Script>
      <Script
        src="https://cdn.userway.org/widget.js"
        data-account="Jy1Jfc6yQm"
        strategy="lazyOnload"
      />

      <>
        {config.core.appEnvironment === 'prd' ? (
          <>
            <Script
              id="google-tag-manage-script"
              strategy="lazyOnload"
              dangerouslySetInnerHTML={{
                __html:
                  '!function(e,t,a,n){e[n]=e[n]||[],e[n].push({"gtm.start":(new Date).getTime(),event:"gtm.js"});e=t.getElementsByTagName(a)[0],n=t.createElement(a);n.async=!0,n.src="https://www.googletagmanager.com/gtm.js?id=GTM-5GZQ3BH",e.parentNode.insertBefore(n,e)}(window,document,"script","dataLayer");',
              }}
            />

            <Script
              id="newsbreak-pixel"
              strategy="lazyOnload"
              dangerouslySetInnerHTML={{
                __html:
                  '!(function (e, n, t, i, p, a, s) {e[i] ||(((p = e[i] =function () {p.process ? p.process.apply(p, arguments) : p.queue.push(arguments);}).queue = []),(p.t = +new Date()),((a = n.createElement(t)).async = 1),(a.src = "https://static.newsbreak.com/business/tracking/nbpixel.js?t=" + 864e5 * Math.ceil(new Date() / 864e5)),(s = n.getElementsByTagName(t)[0]).parentNode.insertBefore(a, s));})(window,document,"script","nbpix"),nbpix("init", "ID-1649485185595379713"),nbpix("event", "pageload");',
              }}
            />

            <FacebookPixel />
            <GA4Pixel />
            <CriteoGum />
            <RedditPixel />

            <Script
              id="taboola-script-1248460"
              strategy="lazyOnload"
              dangerouslySetInnerHTML={{
                __html:
                  '!function(t,e,c){document.getElementById(c)||(t.async=1,t.src="//cdn.taboola.com/libtrc/unip/1248460/tfa.js",t.id=c,e.parentNode.insertBefore(t,e))}(document.createElement("script"),document.getElementsByTagName("script")[0],"tb_tfa_script");',
              }}
            />

            <Script
              type="text/javascript"
              src="https://dynamic.criteo.com/js/ld/ld.js?a=127863&a=24273"
              async={true}
              strategy="lazyOnload"
            />

            <img
              src="//insurance.mediaalpha.com/p/OoJ6UU-BDnAnPsqYoNTk2y983osKdQ.gif"
              width="1"
              height="1"
              alt=""
            />
          </>
        ) : null}
      </>
    </>
  );
}
